if (!customElements.get('infinite-scroll-pagination')) {
  customElements.define(
    'infinite-scroll-pagination',
    class InfiniteScrollPagination extends HTMLElement {
      constructor() {
        super();
        this.grid = this.parentElement
          ? this.parentElement.querySelector('[data-infinite-scroll-grid]')
          : null;
        this.link = this.querySelector('a[rel="next"]');
        this.spinner = this.querySelector('.loading__spinner');
        this.status = this.querySelector('[data-infinite-scroll-status]');
        this.loading = false;

        if (!this.grid || !this.link) return;

        this.classList.add('is-active');

        this.observer = new IntersectionObserver(
          (entries) => {
            if (entries[0].isIntersecting) this.loadNextPage();
          },
          { rootMargin: '600px 0px' }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      loadNextPage() {
        if (this.loading) return;
        this.loading = true;
        this.observer.disconnect();
        if (this.spinner) this.spinner.classList.remove('hidden');

        fetch(this.link.href)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const newItems = html.querySelector('[data-infinite-scroll-grid]');

            if (newItems) {
              const addedCount = newItems.children.length;
              const fragment = document.createDocumentFragment();
              Array.from(newItems.children).forEach((item) => fragment.appendChild(item));
              this.grid.appendChild(fragment);

              if (typeof initializeScrollAnimationTrigger === 'function') {
                initializeScrollAnimationTrigger(this.grid);
              }

              if (this.status) {
                this.status.textContent = this.status.dataset.template.replace('[count]', addedCount);
              }
            }

            history.replaceState(history.state, '', this.link.href);

            const newPagination = html.querySelector('infinite-scroll-pagination');
            if (newPagination) {
              this.replaceWith(newPagination);
            } else {
              this.remove();
            }
          })
          .catch(() => {
            this.loading = false;
            this.classList.remove('is-active');
            if (this.spinner) this.spinner.classList.add('hidden');
            this.observer.observe(this);
          });
      }
    }
  );
}
